import { cx } from '@linaria/core';
import { forwardRef } from 'react';
import { resets } from '@ui/css';
import { FloatingActionButton, CrossIcon } from '@ui/kit';
import { axisContext } from './context.js';
import { wrapper, list, closeButton } from './menu.style.js';
import { jsx } from 'react/jsx-runtime';

function FloatingActionButtonsContextMenu(props) {
  return /*#__PURE__*/jsx(axisContext.Provider, {
    value: props.axis,
    children: /*#__PURE__*/jsx("div", {
      className: cx(resets.rootCls, wrapper, props.className, props.axis),
      children: /*#__PURE__*/jsx("ul", {
        className: list,
        children: props.children
      })
    })
  });
}
const FloatingCloseButton = /*#__PURE__*/forwardRef(function FloatingCloseButton(props, ref) {
  return /*#__PURE__*/jsx(FloatingActionButton, {
    ref: ref,
    tooltip: {
      ariaType: "label",
      body: props.tooltip,
      placement: "right"
    },
    className: closeButton,
    onClick: props.onClick,
    disabled: props.disabled,
    children: /*#__PURE__*/jsx(FloatingActionButton.Icon, {
      children: /*#__PURE__*/jsx(CrossIcon, {
        height: "24",
        strokeWidth: 0.5
      })
    })
  });
});

export { FloatingActionButtonsContextMenu, FloatingCloseButton };
//# sourceMappingURL=menu.js.map
